// hooks/useCustomerAuthCheck.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const api = axios.create({
  baseURL: 'https://twiqli-server-vercel.vercel.app/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const useCustomerAuthCheck = () => {
  const { isCustomerAuthenticated, customerToken, customerLogout } = useAuth();
  const [isTokenValid, setIsTokenValid] = useState(true);
  const [showLoginDialog, setShowLoginDialog] = useState(false);

  useEffect(() => {
    const checkTokenValidity = async () => {
      if (isCustomerAuthenticated && customerToken) {
        try {
          await api.get('/auth/verify-customer-token', {
            headers: { Authorization: `Bearer ${customerToken}` },
          });

          setIsTokenValid(true);
        } catch (error) {
          console.error('Customer token validation error:', error);
          setIsTokenValid(false);
          customerLogout();
          setShowLoginDialog(true);
        }
      }
    };

    checkTokenValidity();
  }, [isCustomerAuthenticated, customerToken, customerLogout]);

  // const handleAuthenticatedAction = (action) => {
  //   if (!isCustomerAuthenticated || !isTokenValid) {
  //     setShowLoginDialog(true);
  //   } else {
  //     action();
  //   }
  // };
  const handleAuthenticatedAction = (action) => {
    if (isCustomerAuthenticated && isTokenValid) {
      action();
    } else {
      setShowLoginDialog(true);
    }
  };

  return {
    isTokenValid,
    showLoginDialog,
    setShowLoginDialog,
    handleAuthenticatedAction,
  };
};

export default useCustomerAuthCheck;
